import { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAppSelector } from "../../hooks/redux";
import { routes } from "./routes";

interface HomeHealthRouteGuardProps {
  children: ReactNode;
}

// Health app routes that home health users can access
const allowedHealthRoutes = [
  "/overview",
  "/chat",
  "/care",
  "/reminders",
  "/ai-coach", // Both /ai-coach and /ai-coach/:conversationId
  "/patient-profile",
  "/settings",
  "/change-password",
  "/change-pin",
  "/contact-support",
  "/faq",
  "/feedback",
  "/privacy",
  "/terms",
];

export const HomeHealthRouteGuard: FC<HomeHealthRouteGuardProps> = ({
  children,
}) => {
  const location = useLocation();
  const { user } = useAppSelector((state) => state.auth);

  // If user has homeHealthId, they should only be able to access health app routes
  if (user?.homeHealthId) {
    // Allow access to health app routes
    const isAllowedRoute = allowedHealthRoutes.some(route => 
      location.pathname.startsWith(route)
    );
    
    if (isAllowedRoute) {
      return <>{children}</>;
    }

    // Redirect to overview for all other routes
    return (
      <Navigate
        to={routes.healthOverview.path}
        replace
      />
    );
  }

  // For non-home health users, allow access to all routes
  return <>{children}</>;
};
